import { render, staticRenderFns } from "./ButtonDownloadPhoto.vue?vue&type=template&id=7dba915c"
import script from "./ButtonDownloadPhoto.vue?vue&type=script&lang=js"
export * from "./ButtonDownloadPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports